/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/reInviteUser.config.json";
import notification from "../config/notifications.config.json";
import { VApplication } from "../../../application";
import { AppNavigatorService } from "../../appNavigatorService";
import { RE_INVITE_USER } from "../graphql";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

import axios from "axios";

export interface reInviteUserProps {
  vuid: string;
  presentation: any;
}

export interface IReInviteUserMethods extends IPluginMethodMap {
  getReInviteUser(args: reInviteUserProps): Promise<any>;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

const LoginPageServ = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export class ReInviteUserService implements IAgentPlugin {
  readonly methods: IReInviteUserMethods;

  constructor() {
    this.methods = {
      getReInviteUser: this.getReInviteUser.bind(this),
    };
  }

  async getReInviteUser(args: reInviteUserProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const srv = LoginPageServ();
    console.log(args)
    try {
      const res = await client.mutate({
        mutation: RE_INVITE_USER,
        variables: {
          input: {
            vuid: args?.vuid,
            presentation: args?.presentation
          },
        },
        fetchPolicy: "no-cache",
      });
      if (res?.data) {
        return {
          data: res?.data?.message,
          notification: notification?.reInviteUser,
        };
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
